import React from 'react';
import { useController } from 'react-hook-form';
import styled from 'styled-components';
import { FaCheck } from 'react-icons/fa';

import { ErrorMessage } from 'playup-web-core';

const ControlledPortalCheckBox = ({
	fieldName,
	label,
	className,
	onClick,
	smallLabel,
}: ControlledPortalCheckBoxProps) => {
	const {
		field,
		fieldState: { error },
	} = useController({
		name: fieldName,
	});

	return (
		<Wrapper className={className}>
			<CheckBoxContainer>
				<CheckBoxInput
					name={fieldName}
					type="checkbox"
					onClick={onClick}
					ref={field.ref}
					value={field.value}
					onChange={(e) => {
						field.onChange(e.target.checked);
					}}
				/>
				{field.value && <CheckIcon />}
			</CheckBoxContainer>
			{label && (
				<StyledLabel smallLabel={smallLabel} htmlFor={fieldName}>
					{label}
				</StyledLabel>
			)}
			{error && <ErrorMessage>{error.message}</ErrorMessage>}
		</Wrapper>
	);
};

export default ControlledPortalCheckBox;

interface ControlledPortalCheckBoxProps {
	fieldName: string;
	label?: string;
	className?: string;
	onClick?: () => void;
	smallLabel?: boolean;
}

const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	position: 'relative',
});

const CheckBoxContainer = styled.div(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '24px',
	height: '24px',
	flexShrink: 0,
	border: '2px solid',
	borderColor: theme.colors.greyR,
	borderRadius: '2px',
	cursor: 'pointer',
}));

const CheckBoxInput = styled.input({
	width: '100%',
	height: '100%',
	opacity: 0,
	cursor: 'pointer',
});

const CheckIcon = styled(FaCheck)(({ theme }) => ({
	position: 'absolute',
	color: theme.colors.success,
	height: '16px',
	width: '16px',
	pointerEvents: 'none',
}));

const StyledLabel = styled.label<{ smallLabel?: boolean }>(({ theme, smallLabel }) => ({
	color: theme.colors.darkR,
	fontSize: smallLabel ? '11px' : '14px',
	fontWeight: 600,
	marginLeft: '10px',
	marginTop: 0,
	marginBottom: 0,
	lineHeight: smallLabel ? '15px' : '18px',
	userSelect: 'none',
}));
